// API Configuration
// Uses environment variable in production, falls back to production API
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://fire-safety-api.tedguy280.workers.dev';

/**
 * Centralized API request function that automatically includes Authorization header
 * @param endpoint - API endpoint (e.g., '/api/facilities')
 * @param options - Fetch options
 * @returns Promise<Response>
 */
export async function apiRequest(endpoint: string, options: RequestInit = {}): Promise<Response> {
    // Get token from localStorage (try both possible keys)
    const token = localStorage.getItem('token') || localStorage.getItem('accessToken');

    // Build headers with auth if token exists
    const headers: HeadersInit = {
        'Content-Type': 'application/json',
        ...(options.headers as Record<string, string>),
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    // Make the request
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers,
    });

    return response;
}

/**
 * Helper function for GET requests
 */
export async function apiGet(endpoint: string): Promise<Response> {
    return apiRequest(endpoint, { method: 'GET' });
}

/**
 * Helper function for POST requests
 */
export async function apiPost(endpoint: string, data?: any): Promise<Response> {
    return apiRequest(endpoint, {
        method: 'POST',
        body: data ? JSON.stringify(data) : undefined,
    });
}

/**
 * Helper function for PUT requests
 */
export async function apiPut(endpoint: string, data?: any): Promise<Response> {
    return apiRequest(endpoint, {
        method: 'PUT',
        body: data ? JSON.stringify(data) : undefined,
    });
}

/**
 * Helper function for DELETE requests
 */
export async function apiDelete(endpoint: string): Promise<Response> {
    return apiRequest(endpoint, { method: 'DELETE' });
}
